<template>
  <vue-simple-markdown
    :linkify="true"
    :prerender="preRenderFn"
    :postrender="postRenderFn"
    :source="source"
  />
</template>

<script>
import _replace from 'lodash/replace'
export default {
  name: 'Markdown',
  props: {
    source: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {
    postRenderFn(html) {
      // Create Router Buttons from Markdown
      // e.g. ~router-btn title="Call to Action"~(/signup)
      html = _replace(
        html,
        new RegExp(/\~router-btn title\="(.*?)"\~\((.*?)\)/, 'gi'), // eslint-disable-line
        (match, title, link) => {
          return `<a href="${link}" class="v-btn v-btn--depressed v-btn--flat v-btn--outlined v-btn--router theme--dark v-size--large blue--text text--darken-2"><span class="v-btn__content">${title}</span></a>`
        }
      )
      // Create inline relative link from Markdown
      // e.g. ~relative-link title="Shop Settings"~(/admin/shop)
      html = _replace(
        html,
        new RegExp(/\~relative-link title\="(.*?)"\~\((.*?)\)/, 'gi'), // eslint-disable-line
        (match, title, link) => `<a href="${link}">${title}</a>`
      )
      return html.replace(/\\-/g, '-')
    },
    preRenderFn(source) {
      let footerWhiteSpacesRegex = /\n{2}\s{2}(\[)/gm
      source = source.replace(footerWhiteSpacesRegex, '  [')

      let footerLinksRegex = /\s{2}(\[[^[]+\]):\s{1}(.*)/gm
      _replace(
        source,
        footerLinksRegex,
        (fullyQualifiedMatch, numberMatch, url) => {
          let numberRegex = _replace(
            numberMatch,
            /\[|\]/g,
            (bracket) => `\\${bracket}`
          )
          source = _replace(source, fullyQualifiedMatch, '')
          source = _replace(source, new RegExp(numberRegex, 'g'), `(${url})`)
        }
      )
      source = source.trim()
      source = source.replace(/\\_/g, '_')
      return source
    },
  },
}
</script>

<style lang="css">
.markdown-body a.v-btn:hover {
  text-decoration: none;
}
</style>
